


























































import { validateEmail } from '@/functions';
import { AuthenticationDispatches } from '@/store/authentication.module';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LoginView extends Vue {
  protected isValid: boolean = false;
  protected hasError: boolean = false;
  protected username: string = '';
  protected password: string = '';
  protected rules = {
    username: [
      (username: string) =>
        username.trim().length > 0 ||
        'O e-mail de usuário é requerido.',
      (username: string) =>
        validateEmail(username) ||
        'Por favor, informe um e-mail válido.',
    ],
    password: [
      (password: string) =>
        password.trim().length >= 8 ||
        'Por favor, informe uma senha de pelo menos oito caracteres.',
    ],
  };

  get serverMessage(): string {
    return this.$store.state.authentication.operationResponse.message;
  }

  protected login() {
    this.$store.dispatch(
      AuthenticationDispatches.LOGIN,
      { login: this.username, password: this.password },
    ).then(() => {
      if (this.$store.state.authentication.isAuthenticated) {
        this.$router.push('/');
      } else {
        this.hasError = this.$store.state.authentication.operationResponse.status >= 300;
      }
    }).catch((error) => {
      console.log(error);
    });
  }
}
